import { c as _c } from "react/compiler-runtime";
import { alpha, Box, Typography } from "@mui/material";
import clsx from "clsx";
import React, { useRef } from "react";
import { type ArrayItemData } from "#/entities/dataStructures/array/model/arraySlice";
import { NestedStructure } from "#/features/treeViewer/ui/NestedStructure";
import { NodeOverlay } from "#/features/treeViewer/ui/NodeOverlay";
import { useNodeAnimations, useNodeColors } from "#/shared/hooks";
type ArrayItemProps = {
  item: ArrayItemData;
  colorMap?: Record<number | string, string> | null;
  size?: number;
  isGrid?: boolean;
};
export const ArrayItem: React.FC<ArrayItemProps> = t0 => {
  const $ = _c(24);
  const {
    item,
    colorMap,
    size: t1,
    isGrid
  } = t0;
  const size = t1 === undefined ? 42 : t1;
  const valueColor = colorMap?.[String(item.value)];
  const {
    nodeColor
  } = useNodeColors(item.color ?? valueColor, false);
  const isChildNested = Boolean(item.childName);
  const ref = useRef(null);
  const animation = useNodeAnimations(ref, item.animation, item.animationCount);
  let t2;
  if ($[0] !== isGrid) {
    t2 = clsx("array-item", {
      "grid-item": isGrid
    });
    $[0] = isGrid;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isGrid ? 0 : "1px";
  let t4;
  if ($[2] !== nodeColor) {
    t4 = nodeColor && alpha(nodeColor, 0.1);
    $[2] = nodeColor;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "&::before": {
        content: "\"\"",
        position: "absolute",
        right: -1,
        width: "1px",
        height: 32,
        backgroundColor: "primary.light",
        opacity: 0.6
      },
      "&.grid-item": {
        "&::before": {
          height: "100%",
          opacity: 0.3
        }
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== size || $[6] !== t3 || $[7] !== t4) {
    t6 = {
      position: "relative",
      minWidth: size,
      height: size,
      marginLeft: t3,
      backgroundColor: t4,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transition: "background-color 0.1s",
      "&:not(:last-child)": t5
    };
    $[5] = size;
    $[6] = t3;
    $[7] = t4;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== animation || $[10] !== isChildNested) {
    t7 = <NodeOverlay ref={ref} animation={animation} isChildNested={isChildNested} />;
    $[9] = animation;
    $[10] = isChildNested;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      textAlign: "center",
      wordWrap: "none",
      pt: 0.32,
      mx: 1
    };
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== colorMap || $[14] !== isChildNested || $[15] !== item) {
    t9 = isChildNested ? <NestedStructure item={item} colorMap={colorMap} /> : item.value;
    $[13] = colorMap;
    $[14] = isChildNested;
    $[15] = item;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <Typography sx={t8}>{t9}</Typography>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t2 || $[21] !== t6 || $[22] !== t7) {
    t11 = <Box className={t2} sx={t6}>{t7}{t10}</Box>;
    $[19] = t10;
    $[20] = t2;
    $[21] = t6;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
};